





















import BaseComponent from '@/components/base-component.vue';
import UiCepFormat from '@/components/UI/cep-format.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: { UiCepFormat }
})
export default class ClientUnitAddress extends BaseComponent {
  @Prop()
  public data: any[];

  public headers: any = [
    { text: 'Cód.', value: 'codigo' },
    { text: 'Descricao', value: 'descricao' },
    { text: 'Endereço', value: 'logradouro' },
    { text: 'CEP', value: 'cep' },
    { text: 'Bairro', value: 'bairro' },
    { text: 'Cidade', value: 'municipio' },
    { text: 'Estado', value: 'estado' }
  ];
}
